const HALE_GOLD = '#CBA052';
const HALE_GOLD_HOVER = '#b88c42';
const SLATE_900 = '#0f172a';
const SLATE_700 = '#334155';
const SLATE_500 = '#64748b';

export const HaleLoginStyles = {
  container: {
    display: 'flex',
    minHeight: '100dvh',
    width: '100%',
    backgroundColor: '#FFFFFF',
  },
  rightPanel: {
    width: { xs: '100%', md: '40%' },
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: { xs: '2rem 1.5rem', sm: '3rem 2rem', md: '3rem 4rem', lg: '3rem 8rem' },
    backgroundColor: '#FFFFFF',
    minHeight: '100dvh',
    position: 'relative',
    zIndex: 10,
    boxShadow: {
      xs: 'none',
      md: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    },
  },
  rightContent: {
    width: '100%',
    maxWidth: '28rem',
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '1.5rem', md: '2.5rem' },
    position: 'relative',
    flex: 1,
    justifyContent: 'center',
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontWeight: 600,
    fontSize: '0.95rem',
    color: SLATE_500,
    cursor: 'pointer',
    mb: -1,
    fontFamily: 'Inter, sans-serif',
  },
  heading: {
    fontWeight: 700,
    fontSize: { xs: '2rem', md: '2.5rem' },
    lineHeight: 1.25,
    color: SLATE_900,
    fontFamily: 'Inter, sans-serif',
  },
  subHeading: {
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: 1.5,
    color: SLATE_500,
    mt: 0.75,
    mb: { xs: 0, md: 1 },
    fontFamily: 'Inter, sans-serif',
  },
  otpDesc: {
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.5,
    color: SLATE_500,
    fontFamily: 'Inter, sans-serif',
  },
  phoneNo: {
    fontWeight: 600,
    color: SLATE_900,
  },
  changePhoneNo: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: HALE_GOLD,
    cursor: 'pointer',
    ml: 0.5,
    '&:hover': {
      color: HALE_GOLD_HOVER,
    },
  },
  formContainer: {
    mb: '1.5rem',
  },
  otpContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  resendCode: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: SLATE_500,
    fontFamily: 'Inter, sans-serif',
    transition: 'color 0.2s ease',
  },
  resendCodeActive: {
    color: HALE_GOLD,
    '&:hover': {
      color: HALE_GOLD_HOVER,
    },
  },
  otpTimer: {
    fontWeight: 400,
    color: SLATE_900,
  },
  submitBtn: {
    width: '100%',
    height: 'auto',
    minHeight: '3.5rem',
    py: 2,
    borderRadius: '12px',
    background: `${HALE_GOLD} !important`,
    color: '#ffffff !important',
    fontWeight: 700,
    fontSize: '1.125rem',
    textTransform: 'none',
    boxShadow: `0 10px 15px -3px rgba(203, 160, 82, 0.3), 0 4px 6px -4px rgba(203, 160, 82, 0.3)`,
    transition: 'all 0.3s ease',
    fontFamily: 'Inter, sans-serif',
    '&:hover': {
      background: `${HALE_GOLD_HOVER} !important`,
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
      transform: 'translateY(-4px)',
    },
    '&.Mui-disabled': {
      background: '#e2e8f0 !important',
      color: SLATE_500,
      boxShadow: 'none',
      transform: 'none',
    },
  },
  termsText: {
    textAlign: 'center',
    mt: 3,
    fontSize: '0.75rem',
    color: SLATE_500,
    lineHeight: 1.625,
    fontWeight: 500,
    fontFamily: 'Inter, sans-serif',
    '& strong': {
      color: SLATE_700,
      fontWeight: 700,
    },
  },
  termsLink: {
    color: 'inherit',
    textDecoration: 'underline',
    fontWeight: 500,
    '&:hover': {
      color: HALE_GOLD,
    },
  },
  poweredByRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 'auto',
    paddingTop: '2rem',
  },
};
